var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_858",
    "data-name": "Group 858",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.878,
    height: 26.24,
    viewBox: "0 0 27.878 26.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 27.878,
    height: 26.24,
    fill: "#0667e9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M27.267,5.4a2.825,2.825,0,0,0-2.2-1.086H7.191L6.633,2.143A2.822,2.822,0,0,0,3.9,0H.91A.914.914,0,0,0,0,.91a.914.914,0,0,0,.91.91H3.9a.97.97,0,0,1,.939.734L8.424,16.818a2.822,2.822,0,0,0,2.73,2.143H22.865a2.8,2.8,0,0,0,2.73-2.143l2.2-9.04A2.691,2.691,0,0,0,27.267,5.4ZM26.005,7.367l-2.2,9.04a.97.97,0,0,1-.939.734H11.153a.97.97,0,0,1-.939-.734L7.661,6.164H25.066a.973.973,0,0,1,.763.382.921.921,0,0,1,.176.822Z",
    fill: "#0667e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M169.373,384.159a3.052,3.052,0,1,0,3.053,3.052A3.069,3.069,0,0,0,169.373,384.159Zm0,4.256a1.2,1.2,0,1,1,1.2-1.2,1.229,1.229,0,0,1-1.2,1.2",
    transform: "translate(-157.604 -364.024)",
    fill: "#0667e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M362.013,384.159a3.052,3.052,0,1,0,3.052,3.052A3.069,3.069,0,0,0,362.013,384.159Zm0,4.256a1.2,1.2,0,1,1,1.2-1.2,1.229,1.229,0,0,1-1.2,1.2",
    transform: "translate(-340.147 -364.024)",
    fill: "#0667e9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.a0a004974b3f782e402208e13eb7b6a4.svg";
export { ForwardRef as ReactComponent };